import React from 'react';
import Box from '../Box/Box.js';
import Spinner from '../Spinner/Spinner.js';

const TextInputInnerVisualSlot = ({
  children,
  hasLoadingIndicator,
  showLoadingIndicator,
  visualPosition
}) => {
  if (!children && !hasLoadingIndicator || visualPosition === 'leading' && !children && !showLoadingIndicator) {
    return null;
  }
  if (!hasLoadingIndicator) {
    return /*#__PURE__*/React.createElement("span", {
      className: "text-input-visual"
    }, children);
  }

  // @TODO: display none may not be the accessible choice here
  // should do {children && <Box sx={{visibility: showLoadingIndicator ? 'hidden' : 'visible'}}>{children}</Box>}
  return /*#__PURE__*/React.createElement("span", {
    className: "text-input-visual"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    position: "relative"
  }, children && /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: showLoadingIndicator ? 'none' : 'revert'
    }
  }, children), /*#__PURE__*/React.createElement(Spinner, {
    "aria-label": 'Loading',
    sx: children ? {
      position: 'absolute',
      top: 0,
      height: '100%',
      maxWidth: '100%',
      visibility: showLoadingIndicator ? 'visible' : 'hidden',
      ...(visualPosition === 'leading' ? {
        left: '0px'
      } : {
        right: '0px'
      })
    } : {
      visibility: showLoadingIndicator ? 'visible' : 'hidden'
    },
    size: children ? undefined : 'small'
  })));
};
TextInputInnerVisualSlot.displayName = "TextInputInnerVisualSlot";
var TextInputInnerVisualSlot$1 = TextInputInnerVisualSlot;

export { TextInputInnerVisualSlot$1 as default };
